import Vue from "vue";
import VueI18n from "vue-i18n";

import en_gb from "./en_gb";

Vue.use(VueI18n);

const messages = {
  en_gb,
};

const i18n = new VueI18n({
  locale: "en_gb",
  messages,
});

export default i18n;
